import { render, staticRenderFns } from "./CopyleaksScan.vue?vue&type=template&id=44a3a856&scoped=true&"
import script from "./CopyleaksScan.vue?vue&type=script&lang=js&"
export * from "./CopyleaksScan.vue?vue&type=script&lang=js&"
import style0 from "./CopyleaksScan.vue?vue&type=style&index=0&id=44a3a856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a3a856",
  null
  
)

export default component.exports